import { useCallback, useContext, useEffect, useState } from 'react';

import { fetchFollower } from '@/services/feed';

import FeedContext from '../FeedContext';
import FollowerSuggestedItem from './FollowerSuggestedItem';

const FollowerSuggested: React.FC<any> = () => {
  const { data } = useContext(FeedContext);

  const [followers, setFollowers] = useState<Array<any> | null>(null);
  const [refreshWhenAccountChange, setRefreshWhenAccountChange] = useState(null);

  const asyncFetchFollower = useCallback(async () => {
    const [data]: any = await fetchFollower({ size: 3, offset: 0 });

    if (data) {
      setFollowers(data?.items);
    }
  }, []);

  useEffect(() => {
    setFollowers(null);
    setRefreshWhenAccountChange(data?.wallet);
  }, []);

  useEffect(() => {
    asyncFetchFollower();
  }, [refreshWhenAccountChange, data?.refreshWhenFollowNewUser]);

  return (
    <div className="sticky top-24 flex w-full flex-col items-start gap-4">
      <span className="text-20 font-semibold text-gray-500">Suggested for you</span>
      {followers?.map((follower) => (
        <FollowerSuggestedItem follower={follower} key={follower.id} />
      ))}
    </div>
  );
};

export default FollowerSuggested;
